<template>
  <div class="relative flex">
    <span class="absolute inset-0 flex items-center justify-center">
      <slot />
    </span>
    <svg class="block" viewBox="0 0 36 36">
      <path
        class="text-static-default-mid fill-transparent stroke-[#C4C4C4] stroke-[0.19rem]"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        :class="pathClassNames"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        :stroke-dasharray="`${value}, 100`"
      />
    </svg>
  </div>
</template>

<script>
import { tw } from '@backmarket/utils/string/tw'

export default {
  props: {
    value: {
      type: Number,
      required: true,
      validator: (value) => {
        return value >= 0 && value <= 100
      },
    },
  },
  computed: {
    pathStrokeColorClass() {
      return {
        [tw`stroke-[#78E5A9]`]: this.value > 90,
        [tw`stroke-[#D6B6FF]`]: this.value > 50 && this.value <= 90,
        [tw`stroke-[#FFEE76]`]: this.value > 25 && this.value <= 50,
        [tw`stroke-[#FB6D72]`]: this.value <= 25,
      }
    },
    pathClassNames() {
      return [
        this.pathStrokeColorClass,
        tw`fill-transparent stroke-[0.19rem]`,
        this.$style.path,
      ]
    },
  },
}
</script>

<style module>
.path {
  stroke-linecap: round;
  animation: pathAnimation 2s ease-out forwards;
}
@keyframes pathAnimation {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>
